<button
    qpxButton
    matButton="outlined"
    size="sm"
    class="no-disabled-color min-w-0 max-w-full overflow-hidden px-2! label-truncate"
    [style.border-radius]="joined() ? '0' : 'var(--qpx-radius-sm)'"
    [disabled]="disabled() || pending()"
    [attr.aria-label]="`Preview ${fileName()}`"
    [attr.aria-busy]="pending() ? 'true' : null"
    (click)="preview()"
>
    @if (parts().badge; as badge) {
        <qpx-file-type-icon
            matButtonIcon
            appearance="boxed"
            size="sm"
            tone="muted"
            style="--qpx-file-type-icon-min-size: 24px"
            [extension]="badge.label"
        />
    }
    <span
        qpxOverflow
        #overflow="qpxOverflow"
        class="block min-w-0 max-w-44 truncate"
        [qpxTooltip]="fileName()"
        [matTooltipDisabled]="!overflow.isOverflowing()"
        >{{ parts().title }}</span
    >
</button>
